var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairK(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 169,
    viewBox: "0 0 176 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 32C131 53.5391 117.539 71 96 71C74.4609 71 60 53.5391 60 32C60 10.4609 74.4609 0 96 0C117.539 0 131 10.4609 131 32Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.002 31.9278C128.787 30.9927 137.308 21.0228 137.96 5.00276C138.005 3.89911 137.099 2.99953 135.995 3.00067C114.443 3.02307 114.009 3.78904 114 29.9847C114 31.0893 114.9 32.0084 116.002 31.9278Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7739 114.972C25.5162 115.013 23.2324 115.079 20.9236 115.169C19.8199 115.212 18.9524 116.187 19.0021 117.291C20.7136 155.261 21.6784 166.953 60.437 168.829C52.8405 162.878 47.0246 154.703 42.976 144.679C41.8769 144.89 40.7434 145 39.585 145C29.4146 145 26.0001 136.493 26.0001 126C26.0001 121.888 26.5243 118.081 27.7739 114.972ZM131.697 168.724C168.533 166.545 169.494 154.612 171.176 117.291C171.226 116.187 170.358 115.212 169.255 115.169C167.57 115.103 165.899 115.05 164.242 115.011C165.48 118.113 166 121.905 166 126C166 136.493 162.586 145 152.415 145C151.257 145 150.123 144.89 149.024 144.679C144.999 154.645 139.228 162.782 131.697 168.724Z",
    className: "HairDark"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9907 27.0158C67.4801 81.8705 46.103 117.389 17.0036 118.947C15.9006 119.006 14.9999 118.055 15.0006 116.95C15.0589 24.9728 19.2104 24.9751 65.598 25.0008L65.9678 25.001C67.0724 25.0016 68.0009 25.9113 67.9907 27.0158Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.292 43.8979C64.6326 86.9511 22.3781 100.908 1.7859 82.9358C0.953704 82.2095 0.991761 80.8983 1.77318 80.1176C74.6248 7.335 77.3572 10.071 108.13 40.884L108.287 41.0417C109.068 41.8233 109.079 43.1223 108.292 43.8979Z",
    className: "Hair"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0216 34.5393C107.244 61.3566 130.964 71.1401 150.015 61.5214C151.001 61.0235 151.308 59.7602 150.755 58.8044C124.294 13.1259 121.433 14.6452 91.7519 31.7985C90.7956 32.3512 90.4499 33.5942 91.0216 34.5393Z",
    className: "Hair"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.009 27.0158C123.52 81.8705 144.897 117.389 173.996 118.947C175.099 119.006 176 118.055 175.999 116.95C175.941 24.9728 171.79 24.9751 125.402 25.0008L125.032 25.001C123.928 25.0016 122.999 25.9113 123.009 27.0158Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairK);
export default __webpack_public_path__ + "static/media/Hair K.976da554d94ba1bc4cad905a1fa9cbe0.svg";
export { ForwardRef as ReactComponent };